export default function NullAvatar({ rank }) {
    return (
        <svg width="100%" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <rect width="100" height="100" rx="8" fill="lightgray" />
            <text x="24" y="28" text-anchor="middle" font-size="12" fill="white" font-weight="bold">{rank}</text>
        </svg>
    )
}